export enum SupplierDocumentStatusKind {
  Error = -999,
  All = -1,
  None = 0,
  Downloaded = 1,
  Processed = 2
}